import { Typography } from "@mui/material";
import { Box, Container } from "@mui/system";
import { Link } from "react-router-dom";

export function Footer() {
  return (
    <Box component="footer" py={4} bgcolor="#111" color="#ccc">
      <Container sx={{ textAlign: 'center' }}>
        <Typography variant="body2" mb={1}>
          © {new Date().getFullYear()} CHOCCHIP STUDIOS LTD. All rights reserved.
        </Typography>
        <Box display="flex" justifyContent="center" gap={3}>
          <Link to="/apps" style={{ color: '#ccc', textDecoration: 'none' }}>Apps</Link>
          <Link to="/tech-stack" style={{ color: '#ccc', textDecoration: 'none' }}>Tech Stack</Link>
          <Link to="/contact" style={{ color: '#ccc', textDecoration: 'none' }}>Contact us</Link>
          <Link to="/about" style={{ color: '#ccc', textDecoration: 'none' }}>About us</Link>
          <a
            href="mailto:admin@nonleaguelive.uk?subject=Delete%20My%20Account"
            style={{ color: '#ccc', textDecoration: 'none' }}
          >
            Request Data Deletion
          </a>
        </Box>
      </Container>
    </Box>
  );
}